import api from './api';

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || '';

export type OmniauthProvider = 'facebook' | 'google_oauth2' | 'apple';

/**
 * Inicia o fluxo OmniAuth (Google/Facebook/Apple) com um POST real de página
 * inteira para `/condomino/auth/:provider`.
 *
 * OmniAuth 2.x só aceita POST nessa rota por padrão (endurecimento contra
 * CSRF, CVE-2015-9284) e valida o token contra a sessão Rails (TokenVerifier
 * em devise.rb) — por isso buscamos o token em `/condomino/csrf_token` antes
 * de montar e submeter um `<form>` real. Precisa ser uma navegação de página
 * inteira (não fetch/XHR) para o browser seguir o redirect do OmniAuth até o
 * provedor.
 *
 * `extraParams` repassa dados como `confirmation_token` (fluxo "confirmar
 * conta com Google/Facebook" — ver OmniAuth.config.before_request_phase).
 */
export async function submitOmniauthRequest(
  provider: OmniauthProvider,
  extraParams: Record<string, string> = {},
): Promise<void> {
  const { data } = await api.get<{ csrf_token: string }>('/condomino/csrf_token');

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `${BACKEND_URL}/condomino/auth/${provider}`;
  form.style.display = 'none';

  const fields: Record<string, string> = { authenticity_token: data.csrf_token, ...extraParams };
  for (const [name, value] of Object.entries(fields)) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
}
